import { jsx } from "react/jsx-runtime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { validateTidalLicense } from "../../base/index.js";
function MoreVert(props) {
  return /* @__PURE__ */ jsx(
    MoreVertIcon,
    {
      "data-testid": "MoreVert",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "MoreVert",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
MoreVert.tidalIconMeta = {
  categories: "common,navigation",
  name: "MoreVert"
};
validateTidalLicense();
export {
  MoreVert
};
//# sourceMappingURL=MoreVert.js.map
